<template>
  <div>
    <div class="section-header">
      <div class="section-headers">Results</div>
      <!-- <div><h-input label="Search" type="search" @blur="findResults()" v-model="search"/></div> -->
    </div>
    <div class="card card--white">
      <div class="card card--container">
        <div v-for="assessment in takenAssessments" :key="assessment.id" class="section">
          <basic-info :assessment="assessment" />
        </div>
        <div v-if="takenAssessments.length == 0 && search">
          No results found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import basicInfo from "./basicInfo";

export default {
  components: {basicInfo},
  data() {
    return {
      loading: true,
      takenAssessments: [],
      search: ""
    };
  },
  created() {
    this.findResults();
  },
  methods: {
    findResults() {
      dataStore.findAll("CoachTakenAssessments", { limit: 200, search: this.search }, { force: true })
        .then(r => {
          this.takenAssessments = r;
        });
    },

  },
};
</script>

